<template>
  <v-container grid-list-md page>
    <v-flex>
      <h1 class="title primary--text my-3">お気に入りリスト</h1>
      <favorite-list/>
    </v-flex>
  </v-container>
</template>

<script>
import FavoriteList from '@/components/FavoriteList.vue'
export default {
  name: 'Favorite',
  components: {
    FavoriteList
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/home/Favorite.vue